import React from 'react'
import { Text } from '@chakra-ui/react'
import { Avatar } from '@chakra-ui/react'

import SharedStack from '~components/shared/wrappers/shared-stack'
import { UserBasicInfoFragment } from '~graphql/generated/graphql'
import {
    getAssigneeAvatarSrc,
    getAssigneeDisplayName,
    getAssigneeInitialsBg,
} from './assignee-avatar'

interface Props {
    user?: UserBasicInfoFragment
}

export default function AssigneeInfo({ user }: Props) {
    return (
        <SharedStack row fit spacing={3}>
            <Avatar
                size="xs"
                src={getAssigneeAvatarSrc(user)}
                name={getAssigneeDisplayName(user)}
                bg={getAssigneeInitialsBg(user)}
            />
            <Text fontSize="sm">
                {user ? `${user.first_name} ${user.last_name}` : 'Unassigned'}
            </Text>
        </SharedStack>
    )
}
